<template>
    <v-col justify="center">
        <v-row justify="center">
            <v-date-picker @change="fechaSelect()" style="max-width: 500px;" v-model="picker" locale="es-py" full-width
                class="mt-4"></v-date-picker>
        </v-row>

        <h3 class="ma-3 grey--text text--darken-2 text-center" v-if="loading">Cargando . . .</h3>



        <v-card max-width="500" class="mx-auto" v-if="personas.length > 0">
            <v-toolbar color="indigo" dark>
                <v-toolbar-title>CUMPLEAÑOS</v-toolbar-title>
            </v-toolbar>

            <h3 class="ma-3 grey--text text--darken-2" v-if="personasFiltrado.length == 0">No hay socios con cumpleaños
                para esta fecha</h3>

            <v-list>
                <v-list-item v-for="item in personasFiltrado" :key="item.codMemSq">
      
                    <v-list-item-content>
                        <v-list-item-title >
                            <FichaCumpleanos :persona="item" />

                        </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar>
                        <!-- <v-img :src="item.avatar"></v-img> -->
                        <FotoSocio :cedula="item.cedula" class="" />
                    </v-list-item-avatar>
                </v-list-item>
            </v-list>
        </v-card>
    </v-col>

</template>


<script>

import axios from "axios";
import FotoSocio from "@/components/cumpleanos/FotoSocio.vue";
import FichaCumpleanos from "./FichaCumpleanos.vue";

export default {
    data() {
        return {
            loading: true,
            personas: [],
            personasFiltrado: [],
            picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        }
    },
    async mounted() {
        this.loading = true;
        await axios.get('/persona/calendarioCumpleanos').then(
            (response) => {

                this.personas = response.data.map(r => {
                    return { ...r,
                             mes: r.fechaNacimiento.slice(5, 7),
                             dia: r.fechaNacimiento.slice(8, 10),
                            edad: this.calculateAge(new Date(r.fechaNacimiento)) }
                })

            }
        ).catch((err) => console.log(err));
        this.fechaSelect();
        this.loading = false;
    },
    methods: {
        fechaSelect() {
            const mes = this.picker.slice(5, 7);
            const dia = this.picker.slice(8, 10);
            this.personasFiltrado = this.personas.filter(p => p.dia == dia && p.mes == mes);

        },
        calculateAge(birthday) { // birthday is a date
            const ageDifMs = Date.now() - birthday;
            const ageDate = new Date(ageDifMs); // miliseconds from epoch
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        },
    },
    components: {
        FotoSocio,
        FichaCumpleanos
    }
}
</script>